// extracted by mini-css-extract-plugin
export default {"container":"Header_container__oIoQk","tabs":"Header_tabs__1-NMk"};